export const buildInitialRecipeSelections = (choiceGroups = [], optionsByGroup = []) => (
  choiceGroups.map((group, groupIndex) => {
    const slots = Math.max(Number(group.max || group.min || 1), 1);
    const validOptionIds = new Set((optionsByGroup[groupIndex] || []).map((option) => option.id));
    const defaultProductId = validOptionIds.has(group.defaultProductId)
      ? group.defaultProductId
      : '';
    return Array.from({ length: slots }, (_, slotIndex) => (
      slotIndex === 0 ? defaultProductId : ''
    ));
  })
);

